import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Politique de Confidentialité – TrackVibes</title>
        <meta name="description" content="Politique de confidentialité de TrackVibes. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles." />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <div className="max-w-[900px] mx-auto px-6 py-12">
          {/* Logo */}
          <div className="text-center mb-12">
            <Link to="/">
              <img 
                src="/assets/trackvibes-logo.png" 
                alt="TrackVibes" 
                className="h-16 mx-auto"
              />
            </Link>
          </div>

          {/* Content */}
          <article className="prose prose-gray max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Politique de Confidentialité</h1>
            <p className="text-gray-500 mb-8">Dernière mise à jour : 2026</p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Responsable du traitement</h2>
              <p className="text-gray-700 leading-relaxed">
                M. LASLEDJ – Auto entrepreneur<br />
                Siret : 799 191 093 00027<br />
                Châtenay-sur-Seine (77), France<br />
                Email : <a href="mailto:contact@trackvibes.app" className="text-blue-600 hover:underline">contact@trackvibes.app</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Données collectées</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>DJs :</strong> nom DJ, email, mot de passe chiffré, données d'événements, statistiques, abonnement Stripe.
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Utilisateurs finaux :</strong> prénom (facultatif), titres demandés, messages (facultatif), likes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Finalité</h2>
              <p className="text-gray-700 leading-relaxed">
                Gestion des demandes musicales, statistiques, gestion des abonnements et amélioration du service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Paiements</h2>
              <p className="text-gray-700 leading-relaxed">
                Les paiements sont traités par Stripe. Aucune donnée bancaire n'est stockée par TrackVibes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Hébergement</h2>
              <p className="text-gray-700 leading-relaxed">
                Cloudflare (hébergement), MongoDB (base de données), Resend (emails transactionnels).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Droits RGPD</h2>
              <p className="text-gray-700 leading-relaxed">
                Droit d'accès, rectification, suppression, opposition et portabilité.<br />
                Contact : <a href="mailto:contact@trackvibes.app" className="text-blue-600 hover:underline">contact@trackvibes.app</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">7. Suppression de compte</h2>
              <p className="text-gray-700 leading-relaxed">
                Un DJ peut demander la suppression complète de son compte en nous contactant par email.
              </p>
            </section>
          </article>

          {/* Footer */}
          <footer className="mt-16 pt-8 border-t border-gray-200">
            <nav className="flex justify-center gap-6 text-sm text-gray-600">
              <Link to="/privacy" className="hover:text-gray-900 font-medium">Confidentialité</Link>
              <span className="text-gray-300">|</span>
              <Link to="/conditions" className="hover:text-gray-900">Conditions</Link>
              <span className="text-gray-300">|</span>
              <Link to="/mentions-legales" className="hover:text-gray-900">Mentions légales</Link>
            </nav>
            <p className="text-center text-gray-400 text-xs mt-4">© 2026 TrackVibes. Tous droits réservés.</p>
          </footer>
        </div>
      </div>
    </>
  );
}
